import Cookies from "js-cookie"
const TokenKey = "token"
// 获取token
export function getToken() {
  return Cookies.get(TokenKey)
}
// 获取员工ID
export function getuserId() {
  return Cookies.get("employeeId")
}
// 获取机构号
export function getSign() {
  return Cookies.get("organSign")
}
// 获取机构名称
export function getDrugstoreName() {
  const drugstoreName = Cookies.get('drugstoreName') || ''
  if (isAndIos()) {
    return drugstoreName
  } else {
    return decodeURIComponent(drugstoreName)
  }
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
// 获取AppVer
export function getAppVer() {
  return Cookies.get("AppVer")
}
// 获取cilentType
export function getcilentType() {
  return Cookies.get("clientType")
}
// 获取abtest
export function getabtest() {
  return Cookies.get("abtest")
}

// 判断安卓/ios
export function isAndIos() {
  let u = navigator.userAgent
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    return true
  } else if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return false
  }
}

// 判断浏览器内核
export function isBrowser() {
  var browser = {
    versions: (function() {
      var uaIswx = navigator.userAgent
      var app = navigator.appVersion
      return {
        //移动终端浏览器版本信息
        trident: uaIswx.indexOf("Trident") > -1, //IE内核
        presto: uaIswx.indexOf("Presto") > -1, //opera内核
        webKit: uaIswx.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: uaIswx.indexOf("Gecko") > -1 && uaIswx.indexOf("KHTML") == -1, //火狐内核
        mobile: !!uaIswx.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!uaIswx.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: uaIswx.indexOf("Android") > -1 || uaIswx.indexOf("Linux") > -1, //android终端或uc浏览器
        iPhone: uaIswx.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: uaIswx.indexOf("iPad") > -1, //是否iPad
        qq: uaIswx.indexOf("MQQBrowser") > -1, //是否qq浏览器
        webApp: uaIswx.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
      }
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
  return browser
}

//utf-8转码
export function UTFTranslate () {
  var UTFTranslate = {
    Change: function(pValue) {
        return pValue.replace(/[^\u0000-\u00FF]/g, function($0) {
            return escape($0).replace(/(%u)(\w{4})/gi, "&#x$2;")
        });
    },
    ReChange: function(pValue) {
        return unescape(pValue.replace(/&#x/g, '%u').replace(/\\u/g, '%u').replace(/;/g, ''));
    }
  };
  return UTFTranslate
}